export default {"src":"/_next/static/media/footer-texture.649402f5.svg","height":491,"width":1440,"blurWidth":0,"blurHeight":0};